import BaseToolbarFeature from './base-toolbar-feature';
import { getFontSizeFromDataItems, getQuickSetFontSize } from '@com/quick-setting/quick-setting-fontsize';
import { FontSizeBoundaryVal } from '@src/slide/domain/ui-model/element-modeles/property/text/constants/font-size';

/**
 * 网格面板，用于项目符号、数字符号等
 */
export default class BaseFontSizeFeature extends BaseToolbarFeature {
    constructor() {
        super();
    }

    /**
     * 增加/减小字号
     * @param isAddFontSize 是否是增加字号
     */
    public onClick(isAddFontSize, isDrawer?: boolean) {
        const size = this.getFontSize();
        let param;
        if (isAddFontSize) {
            param = {
                size,
                max: FontSizeBoundaryVal.FONT_SIZE_MAX,
            };
        } else {
            param = {
                size: -size,
                min: FontSizeBoundaryVal.FONT_SIZE_MIN,
            };
        }
        if (isDrawer) {
            super.drawerCallback(param);
        } else {
            super.callback(param, {
                clickFrom: 'toolbar',
            });
        }
    }

    /**
     * 是否禁用增加/减小字号按钮
     * @param isAddFontSize 是否是增加字号
     */
    public shouldFontSizeDisabled(isAddFontSize) {
        // 只读状态下禁用字体增减
        const disableItems = this.getAppService().editableServiceLayer?.menuManager.disableItemIds();
        let disabled;
        if (disableItems) {
            disableItems.forEach((item) => {
                if (item.id === this.id) {
                    disabled = true;
                }
            });
        }
        if (disabled) return disabled;

        const items = this.getItems();
        const fontSize = getFontSizeFromDataItems(items);
        if (!fontSize) return true;
        return this.getDisabledStatus(isAddFontSize, fontSize);
    }

    /**
     * 获取下一步设置字体大小
     * @private
     */
    private getFontSize() {
        const items = this.getItems();
        return getQuickSetFontSize(items, this.id);
    }

    private getDisabledStatus(isAddFontSize: boolean, fontSize) {
        const num = fontSize.match(/-([\d|.]*)(\+)?pt/);
        const [, curSize, isMultiplyFonts] = num;
        const limitSize = isAddFontSize ? FontSizeBoundaryVal.FONT_SIZE_MAX : FontSizeBoundaryVal.FONT_SIZE_MIN;
        if (!isMultiplyFonts) {
            return String(curSize) === String(limitSize);
        }
        return isAddFontSize ? Number(curSize) > limitSize : Number(curSize) < limitSize;
    }
}
